export default (params) => ({
  trigger: {
    name: 'promo_box.select_content',
    params: params,
  },
  config: {
    schema: {
      content: {
        type: 'string',
      },
    },
    event: {
      name: 'select_content',
      params: {
        sub_feature: null,
      },
    },
  },
});
